export default "__VITE_ASSET__632d9917__"